import { useState } from 'react';

/**
 * Les filtres d'une liste (recherche, période, pastilles d'état), repliés
 * sur mobile derrière un bouton « Filtres ».
 *
 * Sur grand écran le composant ne change rien : le conteneur est en
 * `display: contents` et le bouton est caché (cf. Mobile.css) — les
 * enfants restent posés dans la page exactement comme avant. Sous 1024 px,
 * le bouton apparaît et les enfants ne se montrent qu'une fois déplié.
 */
function FiltresRepliables({ children, libelle = 'Filtres', actifs = 0 }) {
  const [ouvert, setOuvert] = useState(false);

  return (
    <div className={'filtres-repliables' + (ouvert ? ' filtres-repliables-ouvert' : '')}>
      <button
        type="button"
        className="filtres-repliables-bouton"
        onClick={() => setOuvert((o) => !o)}
        aria-expanded={ouvert}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M3 5h18M6 12h12M10 19h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
        {libelle}
        {actifs > 0 && <span className="filtres-repliables-compte">{actifs}</span>}
        <span className="filtres-repliables-chevron" aria-hidden="true">
          {ouvert ? '▴' : '▾'}
        </span>
      </button>
      <div className="filtres-repliables-corps">{children}</div>
    </div>
  );
}

export default FiltresRepliables;
